var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0.89 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-svgrepo-com (1) 1",
    clipPath: "url(#clip0_196_15556)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.7606 3.23311C2.37328 4.62034 1.60918 6.46503 1.60921 8.42695C1.60914 10.3889 2.37333 12.2335 3.76055 13.6208C5.61077 15.4709 8.33148 16.1992 10.8612 15.5214C11.6599 15.3074 12.4156 14.9575 13.0963 14.4924L17.7691 19.1652L19.6927 17.2415L15.0206 12.5696C15.8514 11.3585 16.2997 9.92737 16.2997 8.42688C16.2997 6.46497 15.5355 4.62048 14.1483 3.23305C12.2982 1.38292 9.57736 0.654628 7.04776 1.33243C5.80872 1.66443 4.67201 2.32163 3.7606 3.23311ZM12.2247 5.1567C13.0982 6.03018 13.5793 7.19165 13.5793 8.42693C13.5793 9.66222 13.0982 10.8236 12.2247 11.6971C11.6505 12.2713 10.9355 12.685 10.1571 12.8936C8.56327 13.3207 6.84937 12.8622 5.68425 11.6971C4.81076 10.8237 4.32969 9.66229 4.32976 8.42687C4.32975 7.19159 4.81087 6.03017 5.68433 5.15657C6.25839 4.58254 6.97342 4.16879 7.75187 3.9602C9.34577 3.53312 11.0596 3.99161 12.2247 5.1567Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_196_15556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.894043)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBlack);
export default __webpack_public_path__ + "static/media/search-black.0f5b230c5b7c70190d3dfc35a5651918.svg";
export { ForwardRef as ReactComponent };